/**
 * Scans every accordion block opted in to FAQ structured data (`data-faq-schema="true"`,
 * set via the accordion block's "Include in FAQ structured data" setting), reads each
 * row's rendered heading/answer text directly from the DOM, and injects a single
 * combined FAQPage JSON-LD script into <head> covering every opted-in accordion on
 * the page. DOM text is used instead of Liquid block settings because a block cannot
 * reliably read its own child blocks' settings from outside their own render pass.
 */
function buildAccordionFaqSchema() {
  const accordions = document.querySelectorAll('.accordion[data-faq-schema="true"]');
  if (!accordions.length) return;

  const mainEntity = [];

  accordions.forEach((accordion) => {
    accordion.querySelectorAll('.details').forEach((details) => {
      const headingElement = details.querySelector('.details__header');
      const contentElement = details.querySelector('.details-content');
      if (!headingElement || !contentElement) return;

      const question = headingElement.textContent.replace(/\s+/g, ' ').trim();
      const answer = contentElement.textContent.replace(/\s+/g, ' ').trim();
      if (!question || !answer) return;

      mainEntity.push({
        '@type': 'Question',
        name: question,
        acceptedAnswer: {
          '@type': 'Answer',
          text: answer,
        },
      });
    });
  });

  if (!mainEntity.length) return;

  const script = document.createElement('script');
  script.type = 'application/ld+json';
  script.textContent = JSON.stringify({
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity,
  });
  document.head.appendChild(script);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', buildAccordionFaqSchema);
} else {
  buildAccordionFaqSchema();
}
